import type { Point } from './contract'

export function isPoint(point: Point | undefined): point is Point {
  return !!point && Number.isFinite(point.latitude) && Number.isFinite(point.longitude)
    && Math.abs(point.latitude) <= 90 && Math.abs(point.longitude) <= 180
}

/** Google Maps handles spoken navigation after the user opens this link. */
export function navigationURL(point: Point, mode: string): string {
  if (!isPoint(point)) throw new Error('Invalid navigation destination.')
  const travelMode: Record<string, string> = {
    drive: 'driving', walk: 'walking', bicycle: 'bicycling', two_wheeler: 'two-wheeler',
  }
  if (!travelMode[mode]) throw new Error('Unsupported travel mode.')
  const url = new URL('https://www.google.com/maps/dir/')
  url.search = new URLSearchParams({
    api: '1', destination: `${point.latitude},${point.longitude}`,
    travelmode: travelMode[mode], dir_action: 'navigate',
  }).toString()
  return url.toString()
}

/** Use only an address from the application's accepted current journey. */
export function addressNavigationURL(address: string, mode = 'drive'): string {
  const destination = address.trim()
  if (!destination || destination.length > 256) throw new Error('Invalid navigation address.')
  const url = new URL(navigationURL({ latitude: 0, longitude: 0 }, mode))
  url.searchParams.set('destination', destination)
  return url.toString()
}
